import React from 'react';
import DrawerTab from 'shared/components/ui/DrawerTab';

/**
 * Tab bar inside a detail drawer. Events and Sessions each had their own copy
 * that differed only in whether it could render a count badge; this is the one
 * both use so the drawers read the same.
 *
 * Tabs: `{ id, label, badge? }`. A badge of 0 or null is not rendered.
 */
export default function DetailTabs({ tabs = [], value, onChange }) {
  if (!tabs.length) return null;

  return (
    <div className="flex items-center gap-1 border-b border-[color:var(--border-default)] px-2" role="tablist">
      {tabs.map((tab) => (
        <DrawerTab
          key={tab.id}
          id={tab.id}
          role="tab"
          label={tab.label}
          badge={tab.badge || null}
          active={value === tab.id}
          onClick={onChange}
        />
      ))}
    </div>
  );
}
